import type {
  UpdateCompanySettingsPayload,
  UpdateCompanySettingsResponse,
} from './types';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import type { UUID } from '~/types/common';

import { updateCompanySettings } from './updateCompanySettings';

/**
 * Custom hook for updating a company's settings using mutations.
 *
 * @deprecated This endpoint is deprecated and shall be replaced by update_company_by_id.
 * @param options - Optional mutation options
 * @returns TanStack Query mutation object
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company/operation/update_vadmin_settings_vadmin_company__company_id__vadmin_settings_post
 */
export const useMutationUpdateCompanySettings = (
  options?: Omit<
    UseMutationOptions<
      UpdateCompanySettingsResponse,
      Error,
      {
        companyId: UUID;
        settings: UpdateCompanySettingsPayload;
      }
    >,
    'mutationFn' | 'onSettled'
  >,
) => {
  return useMutation<
    UpdateCompanySettingsResponse,
    Error,
    {
      companyId: UUID;
      settings: UpdateCompanySettingsPayload;
    }
  >({
    async mutationFn({ companyId, settings }) {
      return updateCompanySettings(companyId, settings);
    },

    ...options,
  });
};
